import { API_URL } from '../constants';
import { fetch } from '../fetchWrapper/fetch';
import type { IGetMenusResponseMenu } from 'src/api/getMenus/types';

export const getMenus = async (): Promise<any> => {
  try {
    const res = await fetch(`${API_URL}/menus`);

    if (!res.ok) throw new Error();

    const { data }: { data: IGetMenusResponseMenu[] } = await res.json();
    return data;
  } catch (e) {
    throw new Error('Could not fetch menus');
  }
};
